module.exports = __webpack_public_path__ + "static/media/iconcamera.345c6393.svg";